import React, { useState } from "react";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import {
  getAuth,
  signInWithEmailAndPassword,
} from "firebase/auth";
import axios from "axios";
import xMarkIcon from "../assets/icons/xmark.svg";

interface AccountProfileModalProps {
  auth: any;
  db: any;
  currentUser: any;
}

const AccountSubscriptionModal = ({
  auth,
  db,
  currentUser,
}: AccountProfileModalProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [id, setId] = useState(currentUser.id || "");
  const [account, setAccount] = useState(currentUser.account || "None");
  const [stripeSessionId, setStripeSessionId] = useState(currentUser.stripeSessionId || "");
  const [currentPeriodEnd, setCurrentPeriodEnd] = useState(currentUser.currentPeriodEnd || "");
  const [email, setEmail] = useState(currentUser.email || "");
  const [showCancelButton, setShowCancelButton] = useState(true);
  const [showConfirmCancelModal, setShowConfirmCancelModal] =
  useState<boolean>(false);
const [confirmCancelPassword, setConfirmCancelPassword] =
  useState<string>("");
const [isCancelingSubscription, setIsCancelingSubscription] = useState(false);


  const inputStyle: React.CSSProperties = {
    boxSizing: "border-box",
    margin: "0 0 1rem 0",
    padding: "0.5rem",
    border: "1px solid #ccc",
    borderRadius: "4px",
    width: "100%",
  };

  function formatDateToDDMMYYYY(isoString: string) {
    if (!isoString) return "";
    const date = new Date(isoString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const handleCancelSubscriptionClick = () => {
    setShowConfirmCancelModal(true);
  };

  // This function will be called when the user confirms the cancellation in the modal
  const handleConfirmCancelSubscription = async () => {
    const auth = getAuth();
    try {
      await signInWithEmailAndPassword(auth, email, confirmCancelPassword);
      setShowConfirmCancelModal(false);
      setConfirmCancelPassword("");
      handleCancelSubscription(stripeSessionId);
    } catch (error: any) {
      if (error.code === "auth/wrong-password") {
        alert("Password is incorrect.");
      } else {
        // Handle other errors
        alert("Password is incorrect.");
      }
    }
  };

  const handleCancelSubscription = async (stripeSessionId: string) => {
    setIsCancelingSubscription(true);
    try {
      const cloudFunctionURL =
        "https://europe-west2-motics-consultations.cloudfunctions.net/cancel_stripe";
      // console.log("Cancelling subscription for session_id:", stripeSessionId);
      const response = await axios.post(
        cloudFunctionURL,
        { session_id: stripeSessionId }, // Data payload
        {
          headers: {
            "Content-Type": "application/json",
          },
        } // Axios request configuration
      );

      // console.log("Response:", response);
      const data = response.data; // No need for `await` here
      if (response.status === 200) {
        const date = new Date(response.data.current_period_end * 1000);
        // Format the date as dd/mm/yyyy
        const currentPeriodEnd =
          date.getDate().toString().padStart(2, "0") +
          "/" +
          (date.getMonth() + 1).toString().padStart(2, "0") +
          "/" + // Months are zero-indexed
          date.getFullYear();

        // console.log("current_period_end: ", currentPeriodEnd);
        setCurrentPeriodEnd(currentPeriodEnd);
        setShowCancelButton(false);
        // console.log("Subscription cancelled:", data);
        const userDocRef = doc(db, "users", id);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          const userData = userDocSnap.data();
          if (userData.stripeSessionId) {
            await updateDoc(userDocRef, {
              // lastStripeSessionId: userData.stripeSessionId,
              // stripeSessionId: deleteField(),
              // account: "None",
              currentPeriodEnd: currentPeriodEnd,
              cancelled: "True",
            });
          }
        }
        alert("Your subscription has been successfully cancelled.");
      } else {
        alert("Error cancelling subscription.");
        console.error("Error cancelling subscription:", data.error); // Corrected access to error
      }
    } catch (error: any) {
      // Handle any errors that occur during the request
      alert("Error cancelling subscription.");
      console.error(
        "Error during cancellation request:",
        error.response.data || error.message
      );
    }
    setIsCancelingSubscription(false);
  };



  return (
    <div>
        <label
              style={{
                display: "block",
                marginBottom: "0.5rem",
                fontWeight: "bold",
              }}
            >Account</label>
                          <div style={{ marginBottom: "1.5rem" }}>
                {account || "Not Provided"}
              </div>
    {showCancelButton && (
      <button
        className="button-link"
        onClick={handleCancelSubscriptionClick}
        disabled={isCancelingSubscription}
      >
        Cancel Subscription
      </button>
    )}

    {!showCancelButton && stripeSessionId !== "free_trial" && (
      <p>Your subscription will end on {currentPeriodEnd}.</p>
    )}
    {showConfirmCancelModal && (
      <div className="box-sizing-default modal-background">
        <div
          className="box-sizing-default modals"
          id="reset-password-modal"
          style={{ width: "50%" }}
        >
          <button
            className="small-icon-button"
            onClick={() => {
              setShowConfirmCancelModal(false);
              setConfirmCancelPassword("");
            }}
          >
            <img
              src={xMarkIcon}
              className="small-icon-button"
              alt="close"
            />
          </button>
          <h2>Are you sure you want to cancel subscription?</h2>
          <p>
            When cancelled, your subscription will end at the end of your
            trial/ current subscription. You will not have access to the
            copilot after this date.
          </p>
          <p>
            Please enter your password to confirm that you want to cancel
            your subscription.
          </p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              className="box-sizing-default"
              style={{ width: "100%", marginBottom: "1rem" }}
              type="password"
              placeholder="Enter your password"
              value={confirmCancelPassword}
              onChange={(e) => setConfirmCancelPassword(e.target.value)}
            />
            <button
              className="button-small-brand-green"
              style={{ width: "50%", marginBottom: "0.5rem" }}
              onClick={handleConfirmCancelSubscription}
            >
              Confirm
            </button>
            <button
              className="button-small-brand-red"
              style={{
                width: "50%",
                marginBottom: "0.5rem",
              }}
              onClick={() => {
                setShowConfirmCancelModal(false);
                setConfirmCancelPassword("");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
  );
};

export default AccountSubscriptionModal;
